module.exports = __webpack_public_path__ + "static/media/First Light ZTG 0591-Edit_1440.6ec9ff85.jpeg";